export function Kanban() {
  return (
    <svg
      width="646"
      height="362"
      viewBox="0 0 646 362"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.13672"
        y="0.654297"
        width="196"
        height="360.764"
        rx="6.66364"
        fill="#ECE9DF"
        stroke="#B5B2AA"
      />
      <rect
        x="216.047"
        y="0.654297"
        width="213.909"
        height="360.764"
        rx="6.66364"
        fill="#ECE9DF"
        stroke="#B5B2AA"
      />
      <rect
        x="448.863"
        y="0.654297"
        width="196"
        height="274.8"
        rx="6.66364"
        fill="#ECE9DF"
        stroke="#B5B2AA"
      />
      <rect
        x="18.5469"
        y="18.0645"
        width="161.182"
        height="68.0546"
        rx="7.16364"
        fill="#FFFDF9"
      />
      <rect
        x="233.455"
        y="18.0645"
        width="179.091"
        height="68.0546"
        rx="7.16364"
        fill="#FFFDF9"
      />
      <rect
        x="466.273"
        y="18.0645"
        width="161.182"
        height="68.0546"
        rx="7.16364"
        fill="#FFFDF9"
      />
      <rect
        x="18.5469"
        y="104.029"
        width="161.182"
        height="68.0546"
        rx="7.16364"
        fill="#FFFDF9"
      />
      <rect
        x="233.455"
        y="104.029"
        width="179.091"
        height="68.0546"
        rx="7.16364"
        fill="#FFFDF9"
      />
      <rect
        x="466.273"
        y="104.029"
        width="161.182"
        height="68.0546"
        rx="7.16364"
        fill="#FFFDF9"
      />
      <rect
        x="18.5469"
        y="189.99"
        width="161.182"
        height="68.0546"
        rx="7.16364"
        fill="#FFFDF9"
      />
      <rect
        x="233.455"
        y="189.99"
        width="179.091"
        height="68.0546"
        rx="7.16364"
        fill="#FFFDF9"
      />
      <rect
        x="233.455"
        y="275.955"
        width="179.091"
        height="68.0546"
        rx="7.16364"
        fill="#FFFDF9"
      />
      <rect
        x="466.273"
        y="189.99"
        width="161.182"
        height="68.0546"
        rx="7.16364"
        fill="#D7D3C9"
      />
      <rect
        x="18.5469"
        y="275.955"
        width="161.182"
        height="68.0546"
        rx="7.16364"
        fill="#FFFDF9"
      />
      <g filter="url(#filter0_d_4336_40931)">
        <rect
          x="403.253"
          y="127.461"
          width="223.128"
          height="76.4182"
          rx="7.64928"
          transform="rotate(11.2033 403.253 127.461)"
          fill="#FFFDF9"
          stroke="#B5B2AA"
        />
        <circle
          cx="428.746"
          cy="155.448"
          r="6.27131"
          transform="rotate(11.6733 428.746 155.448)"
          fill="#D7D3C9"
        />
        <rect
          x="439.033"
          y="154.338"
          width="52.1362"
          height="6.33342"
          rx="3.16671"
          transform="rotate(11.6733 439.033 154.338)"
          fill="#D7D3C9"
        />
        <rect
          x="419.949"
          y="167.029"
          width="173.221"
          height="6.33714"
          rx="3.16857"
          transform="rotate(11.6733 419.949 167.029)"
          fill="#ECE9DF"
        />
        <rect
          x="417.281"
          y="179.943"
          width="144.316"
          height="6.33714"
          rx="3.16857"
          transform="rotate(11.6733 417.281 179.943)"
          fill="#ECE9DF"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_4336_40931"
          x="383.818"
          y="124.873"
          width="242.898"
          height="127.489"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.12549 0 0 0 0 0.0823529 0 0 0 0 0.0823529 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4336_40931"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4336_40931"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
